import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { getBuilderModelName } from "@/libs/builder/tools/getBuilderModelName";
import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const loyaltySoftGateInputs = [
  {
    name: "logoSrc",
    type: "file",
    required: false,
    defaultValue:
      "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2F9d1d2ffe26704533a8ad5fbf1abac751",
  },
  {
    name: "title",
    type: "richText",
    required: true,
    defaultValue:
      "Ploom Club is an additional service, where you can receive discounts on orders by collecting points. Are you interested to learn more about Ploom Club?",
  },
  {
    name: "okBtnTitle",
    type: "string",
    required: true,
    defaultValue: "Yes",
  },
  {
    name: "noBtnTitle",
    type: "string",
    required: true,
    defaultValue: "No",
  },
  {
    name: "noBtnLink",
    type: "url",
    required: true,
    defaultValue: "/",
  },
] as const satisfies Inputs;

export const LoyaltySoftGateComponent: RegisteredComponent = {
  name: "Loyalty Soft Gate",
  component: dynamic(
    async () =>
      withValidation(loyaltySoftGateInputs, (await import("./LoyaltySoftGate")).LoyaltySoftGate, "LoyaltySoftGate"),
    { ssr: false }
  ),
  models: [getBuilderModelName("loyalty-soft-gate")],
  inputs: loyaltySoftGateInputs,
  canHaveChildren: true,
  defaultChildren: [],
  childRequirements: {
    message: "You can only put HealthBanner component inside this component",
    query: {
      "component.name": {
        $in: ["HealthBanner"],
      },
    },
  },
};
